import * as React from 'react';

import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {CtaBannerSmall} from 'shells/cta-banner/cta-banner-small';
import {TextRegularAiIcon} from 'shells/icon/svg/text-regular-ai-icon';

import {StickyHeader} from '../../../sticky-header';

import {useGetSessionUser} from '../../../../../core/use-get-session-user';
import {FollowUpTasksOnboardingModal} from '../../../../../lead/onboarding/follow-up-tasks-onboarding/follow-up-tasks-onboarding-modal';
import {useShouldShowFollowUpTasksOnboarding} from '../../../../../lead/onboarding/follow-up-tasks-onboarding/use-should-show-follow-up-task-onboarding';

import {TodoList} from '../todo-list/todo-list';
import {TodoListControls} from '../todo-list-controls';
import type {TodoPeriodSegment} from '../todo-list-controls/todo-list-controls';

import styles from './todo-list-container.module.css';

type Props = {
    onPeriodSegmentChange: (activeSegment: TodoPeriodSegment) => void;
    activePeriodSegment: TodoPeriodSegment;
    formattedDisplayDate: string;
    counts: any;
};

export function TodoListContainer(props: Props) {
    const {user} = useGetSessionUser();
    const [shouldShowOnboardingModal, setShouldShowOnboardingModal] = React.useState(false);
    const [hasDismissedOnboarding, setHasDismissedOnboarding] = React.useState(false);
    const {shouldShow, markSeen} = useShouldShowFollowUpTasksOnboarding(
        Nut_Settings_User.SETTING_HAS_SEEN_FOLLOW_UP_TASKS_TODO_LIST_ONBOARDING
    );

    return (
        <div className={styles.container}>
            <TodoListControls
                onSelect={props.onPeriodSegmentChange}
                activePeriodSegment={props.activePeriodSegment}
                counts={props.counts}
            />
            {shouldShow && !hasDismissedOnboarding && (
                <AiFollowupTaskTodoListOnboarding
                    onClick={() => {
                        setShouldShowOnboardingModal(true);
                    }}
                    onClose={() => {
                        if (markSeen) {
                            markSeen();
                            setHasDismissedOnboarding(true);
                        }
                    }}
                />
            )}
            {shouldShowOnboardingModal && user && (
                <FollowUpTasksOnboardingModal
                    isOpen={shouldShowOnboardingModal}
                    user={user}
                    onClose={() => {
                        if (markSeen) {
                            markSeen();
                        }
                        setShouldShowOnboardingModal(false);
                    }}
                />
            )}
            <StickyHeader>{props.formattedDisplayDate}</StickyHeader>
            <TodoList />
        </div>
    );
}

function AiFollowupTaskTodoListOnboarding(props: {onClick: () => void; onClose: () => void}) {
    const {onClick, onClose} = props;

    return (
        <div className='pad-16'>
            <CtaBannerSmall
                ctaMessageType='ai-info'
                ctaText='Set up'
                icon={TextRegularAiIcon}
                onCtaClick={onClick}
                onClose={onClose}
                text='Never forget to follow-up. Nutshell can now automatically create tasks from call transcriptions'
            />
        </div>
    );
}
